import { createApp } from './main'
import Vue from 'vue'
// require('./common/libs/wap-resize.js');
const { app, router, store } = createApp()
// import * as Sentry from '@sentry/browser'
// Sentry.init({ dsn: 'http://61ef1c1dcef044709fc066fe319763d9@49.232.31.21:9000/5' });
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

var {deviceType, hyBridge} = require('@izk/izk-mobile-jsbridge');
if (deviceType().isInApp) {
  window.mobile = window.mobile ? window.mobile : hyBridge;
}
window.Vue = Vue;
router.onReady(() => {
  // 匹配要渲染的视图后，再获取数据
  if (process.env.NODE_ENV==='development'||!process.env.NODE_ENV) {
    Vue.mixin({
      beforeMount () {
        const { asyncData } = this.$options
        if (asyncData) {
          this.dataPromise = asyncData({
            store: this.$store,
            route: this.$route,
            cookie: document.cookie
          })
        }
      },
      beforeRouteUpdate (to, from, next) {
        const { asyncData } = this.$options
        if (asyncData) {
          asyncData({
            store: this.$store,
            route: to,
            cookie: document.cookie
          }).then(next).catch(next)
        } else {
          next()
        }
      }
    })
  }

  // 在路由导航之前解析数据
  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to)
    const prevMatched = router.getMatchedComponents(from)

    let diffed = false
    const activated = matched.filter((c, i) => {
      return diffed || (diffed = (prevMatched[i] !== c))
    })

    if (!activated.length) {
      return next()
    }

    Promise.all(activated.map(c => {
      if (c.metaData) {
        c.metaData({store, route: to});
      }
      if (c.asyncData) {
        console.log('asyncData in entry-client beforeResolve to:', to);
        return c.asyncData({
          store,
          route: to,
          cookie: document.cookie
        })
      }
    })).then(() => {
      document.title = store.state.meta.title;
      next()
    }).catch(next)
  })

  app.$mount('#app')
})


// WEBPACK FOOTER //
// ./src/entry-client.js